// Local-only personalisation. We never send this to the server — the entire
// history sits in the user's own browser and powers the "Based on your
// searches" home section. This keeps us out of any tracking-cookie territory
// while still giving returning visitors a noticeably more personal page.
const KEY = "sbi_recent_searches_v1";
const MAX_ENTRIES = 8;

const safeRead = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const safeWrite = (entries) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(entries.slice(0, MAX_ENTRIES)));
  } catch {
    /* localStorage may be disabled — fall through silently */
  }
};

export const getRecentSearches = () => safeRead();

export const recordSearch = (query, category = "") => {
  if (!query) return;
  const q = String(query).trim();
  if (!q) return;
  const existing = safeRead().filter(
    (e) => e.query.toLowerCase() !== q.toLowerCase(),
  );
  existing.unshift({ query: q, category, at: Date.now() });
  safeWrite(existing);
};

export const clearRecentSearches = () => {
  try {
    localStorage.removeItem(KEY);
  } catch { /* noop */ }
};
